import { useState, useEffect } from "react";
import { LAST_CHAT_TIMESTAMP_KEY, LAST_CHAT_TIMESTAMP_CHANGED_EVENT } from "../constants";

const ONE_HOUR_UNIX = 60 * 60 * 1000;

export const shouldShowChatCta = (isLoggedIn: boolean): boolean => {
    let lastChatTimestamp;
    try {
        lastChatTimestamp = localStorage.getItem(LAST_CHAT_TIMESTAMP_KEY);
    } catch (e) {
        lastChatTimestamp = null;
    }

    if (!lastChatTimestamp) {
        return false;
    }

    const currentUnixTimestamp = Date.now();
    const lastChatTimestampValue = Number(lastChatTimestamp);
    const within24Hours = currentUnixTimestamp - lastChatTimestampValue < 24 * ONE_HOUR_UNIX;
    const within1Hour = currentUnixTimestamp - lastChatTimestampValue < ONE_HOUR_UNIX;

    return within1Hour || (within24Hours && isLoggedIn);
};

export const useChatCta = (isLoggedIn: boolean): boolean => {
    const [shouldShow, setShouldShow] = useState(() => shouldShowChatCta(isLoggedIn));

    useEffect(() => {
        setShouldShow(shouldShowChatCta(isLoggedIn));

        const handleStorageChange = () => {
            setShouldShow(shouldShowChatCta(isLoggedIn));
        };

        const handleStorageEvent = (e: StorageEvent) => {
            if (e.key === LAST_CHAT_TIMESTAMP_KEY) {
                handleStorageChange();
            }
        };

        window.addEventListener("storage", handleStorageEvent);
        window.addEventListener(LAST_CHAT_TIMESTAMP_CHANGED_EVENT, handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageEvent);
            window.removeEventListener(LAST_CHAT_TIMESTAMP_CHANGED_EVENT, handleStorageChange);
        };
    }, [isLoggedIn]);

    return shouldShow;
};
